import { render, staticRenderFns } from "./VListLoadMore.vue?vue&type=template&id=35298d56&"
import script from "./VListLoadMore.vue?vue&type=script&lang=js&"
export * from "./VListLoadMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports